import { Alert, Box, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PeopleIcon from "@mui/icons-material/People";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import BadgeIcon from "@mui/icons-material/Badge";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import HistoryIcon from "@mui/icons-material/History";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";

export default function AdminPage() {
  const navigate = useNavigate();

  const tileGroups = [
    {
      title: "Online Preliminary Notification Form Email",
      tiles: [
        { label: "Online Preliminary Form Email Blast", path: "/admin/blast-email", icon: BadgeIcon },
        {
          label: "PT Access to Online Preliminary Form",
          path: "/admin/access-levels-test",
          icon: LockPersonIcon
        }
      ]
    },
    {
      title: "Submission Information",
      tiles: [
        { label: "Submissions", path: "/admin/submissions", icon: ListAltIcon },
        { label: "Tax Bill Description Request", path: "/admin/description-request", icon: FactCheckIcon },
        { label: "Reports", path: "/admin/reports?category=submission", icon: AssessmentIcon }
      ]
    },
    {
      title: "Agreement & Authorized Signer Information",
      tiles: [
        {
          label: "Authorized Signer & Parent Jurisdiction Groups Management",
          path: "/admin/authorized-signer",
          icon: HowToRegIcon
        },
        {
          label: "Agreement Workflow & Routing for Adobe Sign",
          path: "/admin/agreement-recipients",
          icon: ContactMailIcon
        },
        { label: "Reports", path: "/admin/reports?category=agreement", icon: AssessmentIcon }
      ]
    },
    {
      title: "Annual Setup & Archival Process",
      tiles: [
        { label: "Submission Period Configuration", path: "/admin/submission-period", icon: EventIcon },
        { label: "Archive Process", path: "/admin/archive-process", icon: HistoryIcon }
      ]
    },
    {
      title: "Admin Portal Access",
      tiles: [{ label: "Admin Users", path: "/admin/users", icon: PeopleIcon }]
    }
  ];

  return (
    <>
      <Box sx={{ my: 2 }}>
        <Alert severity="warning">
          Updates made in Taxsys do not reflect in this Admin portal until the following day.
        </Alert>
      </Box>
      <Box sx={{ pt: 4 }}>
        {tileGroups.map((group) => (
          <Box key={group.title} sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "primary.main" }}>
              {group.title}
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              {group.tiles.map(({ label, path, icon: Icon }) => (
                <Card key={path} sx={{ width: 220, display: "flex" }} elevation={3}>
                  <CardActionArea
                    onClick={() => navigate(path)}
                    sx={{ height: "100%", display: "flex", alignItems: "stretch" }}
                  >
                    <CardContent
                      sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 3, flex: 1 }}
                    >
                      <Icon sx={{ fontSize: 48, color: "primary.main", mb: 1 }} />
                      <Typography variant="subtitle1" fontWeight={600}>
                        {label}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
